import { authedGet, authedWrite } from './apiClient';
import { persistResource } from './store';

export const SERVICE_POINTS_KEY = 'service-points';

export interface ServicePointRow {
  id: number;
  locationCode: string;
  issueDate: string;
  serviceDate: string;
  surveyNumber: string;
  submittedBy: string;
  customerName: string;
  staffName: string;
  points: number;
  issueResolution: string;
  resolved: boolean;
  enteredBy: string;
  enteredAt: string;
}

export interface ServicePointsData {
  rows: ServicePointRow[];
}

export function fetchServicePoints(): Promise<ServicePointsData> {
  return authedGet('/api/v1/company/service-points');
}

export type ServicePointWrite = {
  locationCode: string;
  issueDate: string;
  serviceDate: string;
  surveyNumber: string;
  submittedBy: string;
  customerName: string;
  staffName: string;
  points: number;
  issueResolution: string;
  resolved: boolean;
};

export async function addServicePoint(body: ServicePointWrite): Promise<void> {
  await authedWrite('POST', '/api/v1/company/service-points', body);
}

// Owner rule 2026-09-10: every table has Add and Edit. Mirrors updateLicense
// (lib/licenses.ts) — same PATCH-by-id shape, same authedWrite helper add
// uses, so callers get a fresh Idempotency-Key per call for free.
export async function updateServicePoint(id: number, body: ServicePointWrite): Promise<void> {
  await authedWrite('PATCH', `/api/v1/company/service-points/${id}`, body);
}

export async function deleteServicePoint(id: number): Promise<void> {
  await authedWrite('DELETE', `/api/v1/company/service-points/${id}`, {});
}

export async function reloadServicePoints(): Promise<void> {
  const data = await fetchServicePoints();
  await persistResource(SERVICE_POINTS_KEY, data);
}
